import React, { useCallback } from "react";
import useRootTranslation from "../../../../../hooks/use-root-translation";
import HomeDashboardPageQuery from "../../../../../models/home-dashboard-page-query.model";
import TooltipWarning from "../../../../tooltip-warning";
import { TableRow } from "../../index.styled";
import HeadFilterCell from "../header-cell-filter";
import { HeadCell, Label } from "./index.styled";

export interface HeaderItemFilter {
  value: string;
  label: string | JSX.Element;
}

export interface HeaderItemOrderBy {
  value: "performance" | "resume" | "createdByAsc" | "createdByDesc" | string[];
  label: string | JSX.Element;
}

export interface HeaderItem {
  value: string;
  width?: string;
  query_param?:
    | "process_status"
    | "offer_status"
    | "completed_range"
    | "orderBy";
  filter?: HeaderItemFilter[];
  orderBy?: HeaderItemOrderBy[];
  info?: string;
}

interface HeaderProps {
  headerItems: HeaderItem[];
  handleSearch?: (query: HomeDashboardPageQuery) => void;
}
const Header: React.FC<HeaderProps> = ({ headerItems, handleSearch }) => {
  const { root } = useRootTranslation(
    "ranking-table.headers",
    "private-home-page"
  );

  const getHeadCell = useCallback(
    (item: HeaderItem, index: number) => {
      if (
        (!!item.filter && item.filter.length > 0) ||
        (!!item.orderBy && item.orderBy.length > 0)
      ) {
        return (
          <HeadFilterCell
            item={item}
            key={`header-item-${index}`}
            handleSearch={handleSearch}
          />
        );
      }
      return (
        <HeadCell width={item.width} key={`header-item-${index}`}>
          <Label>
            {root(item.value)}
            {item?.info && (
              <TooltipWarning
                message={root(item?.info)}
                marginLeft=".25rem"
                position="bottom"
                backgroundColor="#fff"
                color="#000"
                borderColor="#000"
              />
            )}
          </Label>
        </HeadCell>
      );
    },
    [root, handleSearch]
  );

  return (
    <TableRow>
      {headerItems.map((item, index) => getHeadCell(item, index))}
    </TableRow>
  );
};

export default Header;
